import { render } from "./DataProtection.vue?vue&type=template&id=232faaff&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=232faaff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-232faaff"

export default script